// Browser geolocation + free reverse geocoding (BigDataCloud, no API key).
export async function detectLocation() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) return reject(new Error("unsupported"));
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const { latitude, longitude } = pos.coords;
        try {
          const r = await fetch(
            `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
          );
          const d = await r.json();
          resolve({
            latitude,
            longitude,
            city: d.city || d.locality || d.principalSubdivision || "",
            country: d.countryCode || "",
            country_name: d.countryName || "",
          });
        } catch {
          resolve({ latitude, longitude, city: "", country: "", country_name: "" });
        }
      },
      (err) => reject(err),
      { timeout: 10000, enableHighAccuracy: false }
    );
  });
}
